import { StandardEvents } from '@shopify/events';

const link = document.querySelector('[data-bb-cart-link]');
if (link) {
  const renderCount = count => {
    if (!Number.isInteger(count) || count < 0) return;
    const badge = link.querySelector('[data-bb-cart-count]');
    badge.textContent = String(count);
    badge.hidden = count === 0;
    link.querySelector('[data-bb-cart-empty]').hidden = count > 0;
    link.querySelector('[data-bb-cart-full]').hidden = count === 0;
    link.setAttribute('aria-label', link.dataset.bbCartLabel.replace('__COUNT__', String(count)));
  };
  document.addEventListener(StandardEvents.cartLinesUpdate, event => {
    event.promise?.then(({ cart, detail }) => {
      renderCount(cart?.totalQuantity ?? detail?.itemCount);
    }).catch(() => {});
  });
  window.addEventListener('pageshow', async event => {
    if (!event.persisted) return;
    try {
      const response = await fetch(link.pathname + '.js', {headers:{Accept:'application/json'},cache:'no-store'});
      if (response.ok) renderCount((await response.json()).item_count);
    } catch {}
  });
}
